import JokerProHeader from "../../components/header/JokerVideoHeader";
import { useTranslation } from "react-i18next";
import Footer from "../../components/footer/Footer";
import MainTemplate from "../Templates/MainTemplate";
import ListView from "./Components/ListView";
import { learnVideoList } from "../../util/CollectionData";
import styles from "./Learn.module.css";
import AssetsPack from "../../util/AssetsPack";

const Learn = () => {
  const { t } = useTranslation();

  const header = (
    <JokerProHeader
      headerText={t("joker_learn_page.tutorial")}
      title={t("joker_learn_page.title_tone_1")}
      highlightLabel={t("joker_learn_page.title_tone_2")}
      description={t("joker_learn_page.sub_title")}
      bgImage={AssetsPack.image.BG_JOKER_LEARN_HEADER}
      image={AssetsPack.image.JOKER_LEARN_HEADER}
    >
      <></>
    </JokerProHeader>
  );

  const body = (
    <div className={styles["body-container"]}>
      <ListView items={learnVideoList} />
    </div>
  );
  return (
    <MainTemplate
      body={body}
      footer={<Footer />}
      header={header}
      fullWidthHeaderIpad
    />
  );
};

export default Learn;
